import { makeStyles } from '@material-ui/core/styles';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import clsx from 'clsx';

import { getColorWithOpacity } from '@/utils/colorHelpers.js';

const useStyles = makeStyles((theme) => ({
    placeholder: {
        display: 'block',
        position: 'relative',
        overflow: 'hidden',
        backgroundColor: getColorWithOpacity(theme.palette.common.yellow, 0.2),
    },
    icon: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '50%',
        height: '50%',
        color: theme.palette.common.yellow,
    },
}));

interface Props {
    className?: string;
    label?: string;
}

export const ProfilePicturePlaceholder = ({ className, label }: Props) => {
    const classes = useStyles();
    const isDecorative = label === undefined;

    return (
        <span
            className={clsx(classes.placeholder, className)}
            role={isDecorative ? undefined : 'img'}
            aria-label={isDecorative ? undefined : label}
            aria-hidden={isDecorative ? true : undefined}
        >
            <PersonOutlineIcon className={classes.icon} />
        </span>
    );
};
